// This order is what was defined by merch team as most important -> least important associations so ensure show in this order if available
export const associationTypeConfigs: AssociationTypeConfig[] = [
  {
    key: 'metals',
    productField: 'c_associationAlternativeMetals',
    selectorI18nKey: 'product_details_page.associations.alternative_metal_types',
    headingI18nKey: 'product_details_page.associations.metal_types_heading',
  },
  {
    key: 'stoneSizes',
    productField: 'c_associationAlternativeStoneSizes',
    selectorI18nKey: 'product_details_page.associations.alternative_stone_sizes',
    headingI18nKey: 'product_details_page.associations.stone_sizes_heading',
  },
  {
    key: 'sizes',
    productField: 'c_associationAlternativeSizes',
    selectorI18nKey: 'product_details_page.associations.alternative_sizes',
    headingI18nKey: 'product_details_page.associations.sizes_heading',
  },
  {
    key: 'widths',
    productField: 'c_associationAlternativeWidths',
    selectorI18nKey: 'product_details_page.associations.alternative_widths',
    headingI18nKey: 'product_details_page.associations.widths_heading',
  },
  {
    key: 'stones',
    productField: 'c_associationAlternativeStones',
    selectorI18nKey: 'product_details_page.associations.alternative_stones',
    headingI18nKey: 'product_details_page.associations.stones_heading',
  },
  {
    key: 'shapes',
    productField: 'c_associationAlternativeShapes',
    selectorI18nKey: 'product_details_page.associations.alternative_shapes',
    headingI18nKey: 'product_details_page.associations.shapes_heading',
  },
  {
    key: 'compliments',
    productField: 'c_associationItemCompliments',
    selectorI18nKey: 'product_details_page.associations.alternative_compliments',
    headingI18nKey: 'product_details_page.associations.compliments_heading',
  },
]
